import { string } from 'prop-types';
import React from 'react';
import { Image } from 'react-native';

import { LAYOUT, C } from '../../common';

const Logo = ({ source, ...inherit }) => (
  <Image
    {...inherit}
    resizeMode="contain"
    source={{ uri: source }}
    style={LAYOUT.STYLE.logo}
  />
);

Logo.propTypes = {
  source: string,
};

Logo.defaultProps = {
  // @TODO: Approach using local files
  // source: Platform.OS === 'web' ? process.env.PUBLIC_URL + '/asset/minube.png' : C.MINUBE_LOGO,
  source: C.MINUBE.LOGO,
};

export default Logo;
